var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{attrs:{"bg-variant":"secondary","text-variant":_vm.isLightColor?'dark':'light',"header":"404","lead":"Diese Seite wurde leider nicht gefunden..."}},[_c('router-link',{staticStyle:{"color":"inherit"},attrs:{"to":"/"}},[_vm._v("Zurück zur Startseite")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }